type Props = {
    title: string
}

// export default function NotAvailable({
//                                          title = "Geen items beskikbaar nie.",
//                                      }: Props) {
//     return (
//         <div className="rounded-lg border border-dashed p-10 text-center">
//             <p className="text-sm text-gray-600">{title}</p>
//         </div>
//     )
// }


export default function NotAvailable({title = "Geen items beskikbaar nie.",}: Props) {
    return (
        <button
            type="button"
            className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-2 focus:outline-offset-2 focus:outline-blue-800"
        >
            <span className="mt-2 block text-sm font-semibold text-blue-900">{title}</span>
        </button>
    )
}
